<template>
    <span class="LiveClock">
        {{time}}
    </span>
</template>
<script>
    export default {
        name: "LiveClock",
        data() {
            return {
                interval: null,
                time: null
            }
        },
        beforeDestroy() {
            // prevent memory leak
            clearInterval(this.interval)
        },
        created() {
            // update the time every second
            this.interval = setInterval(() => {
                let newTime = Intl.DateTimeFormat(navigator.language, {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                }).format();
                this.time = newTime;
                if ((newTime.length == 11 && newTime.substring(6, 8) == "00") || (newTime.length == 10 && newTime.substring(5, 7) == "00")) {
                    this.$emit('evenminute');
                }
            }, 1000)
        },
        UpdateTime() {
            
        }
    };
</script>